export default __webpack_public_path__ + "static/media/photo--lg--129.8dd10daa.jpg";